import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SidebarModal } from '../../../../../components/common/Sidebar/Sidebar';
import { UserStatuses } from './UserStatuses';

import { Tab, FlexJustifyCenter } from './UserVerification.styles';

export const UserVerifications = ({ teamMember }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation('myTeam');
  return (
    <>
      <FlexJustifyCenter>
        {teamMember?.hasNoPackage && (
          <Tab
            onClick={() => {
              setIsOpen(!isOpen);
            }}>
            No Membership order
          </Tab>
        )}
        {teamMember?.hasUnpaidPackage && (
          <Tab
            onClick={() => {
              setIsOpen(!isOpen);
            }}>
            Membership waiting payment
          </Tab>
        )}

        {teamMember?.isNotQualifiedPartner && (
          <Tab
            onClick={() => {
              setIsOpen(!isOpen);
            }}>
            Not Qualified Partner Rank
          </Tab>
        )}
      </FlexJustifyCenter>

      <SidebarModal
        isOpen={isOpen}
        setOpen={setIsOpen}
        title={'User Statuses'}
        sidebarWidth={'511px'}>
        <UserStatuses setIsOpen={setIsOpen} />
      </SidebarModal>
    </>
  );
};
